export default __webpack_public_path__ + "static/media/PrintCheque.f922f9ff.svg";